import { format } from 'date-fns';
import { UserRoles, UserRolesModelApiResponse } from '../user-roles/user-roles.model';

export interface DoctorApiResponse {
  createdAt: string;
  deletedAt: string;
  doctorNumber: string;
  id: string;
  speciality: string;
  specialityGroup: string;
  roleId: string;
  numberOfCases: number;
  title: string;
  type: string;
  updatedAt: string;
  userId: string;
  userRoles: UserRolesModelApiResponse;
  hg: string;
  hug: string;
}

export interface DoctorModel {
  createdAt: Date;
  deletedAt: Date;
  doctorNumber: string;
  id: string;
  speciality: string;
  specialityGroup: string;
  roleId: number;
  title: string;
  type: string;
  updatedAt: Date;
  numberOfCases: number;
  userId: string;
  userRoles: UserRoles;
  hg: string;
  hug: string;
}

export class Doctor implements DoctorModel {
  createdAt = new Date();
  deletedAt = new Date();
  doctorNumber = '';
  id = '';
  speciality = '';
  numberOfCases = -1;
  specialityGroup = '';
  roleId = -1;
  title = '';
  type = '';
  updatedAt = new Date();
  userId = '';
  userRoles = new UserRoles();
  hg = '';
  hug = '';
  constructor(dto?: DoctorModel) {
    if (!dto) {
      return;
    }
    this.createdAt = dto.createdAt;
    this.deletedAt = dto.deletedAt;
    this.doctorNumber = dto.doctorNumber;
    this.id = dto.id;
    this.roleId = Number(dto.roleId);
    this.speciality = dto.speciality;
    this.specialityGroup = dto.specialityGroup;
    this.title = dto.title;
    this.numberOfCases = dto.numberOfCases;
    this.type = dto.type;
    this.updatedAt = dto.updatedAt;
    this.userId = dto.userId;
    this.userRoles = dto.userRoles;
    this.hg = dto.hg;
    this.hug = dto.hug;
  }

  static parseDTO(doctor: DoctorApiResponse): Doctor {
    return new Doctor({
      createdAt: new Date(doctor.createdAt),
      deletedAt: new Date(doctor.deletedAt),
      doctorNumber: doctor.doctorNumber,
      id: doctor.id,
      speciality: doctor.speciality,
      specialityGroup: doctor.specialityGroup,
      numberOfCases: doctor.numberOfCases,
      title: doctor.title,
      roleId: Number(doctor.roleId),
      type: doctor.type,
      updatedAt: new Date(doctor.updatedAt),
      userId: doctor.userId,
      userRoles: doctor.userRoles,
      hg: doctor.hg,
      hug: doctor.hug
    });
  }

  static jsonSerialize(dto: Doctor): DoctorApiResponse {
    return {
      createdAt: format(dto.createdAt, 'yyyy.MM.dd'),
      deletedAt: format(dto.deletedAt, 'yyyy.MM.dd'),
      doctorNumber: dto.doctorNumber,
      id: dto.id,
      speciality: dto.speciality,
      specialityGroup: dto.specialityGroup,
      numberOfCases: dto.numberOfCases,
      title: dto.specialityGroup,
      type: dto.type,
      roleId: JSON.stringify(dto.roleId),
      updatedAt: format(dto.updatedAt, 'yyyy.MM.dd'),
      userId: dto.userId,
      userRoles: dto.userRoles,
      hg: dto.hg,
      hug: dto.hug
    };
  }
}
